module.exports = __webpack_public_path__ + "static/m3max-970455b0baa7e27c1481cc388ae3e87d.png";